import { render } from "./PromotionComponent.vue?vue&type=template&id=5610e8be"
import script from "./PromotionComponent.vue?vue&type=script&lang=js"
export * from "./PromotionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/promotions/PromotionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5610e8be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5610e8be', __exports__)) {
    api.reload('5610e8be', __exports__)
  }
  
  module.hot.accept("./PromotionComponent.vue?vue&type=template&id=5610e8be", () => {
    api.rerender('5610e8be', render)
  })

}


export default __exports__